import { useEffect, useState } from "react";
import { FiBookOpen, FiLock } from "react-icons/fi";
import { Link } from "react-router-dom";
import { getOrganizationFeatureAccess } from "../../api/organizationProfile";
import FetchLoadingState from "../feedback/FetchLoadingState";

export default function FeatureAccessGate({ featureKey, title, children }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    getOrganizationFeatureAccess().then((data) => { if (active) setProfile(data); })
      .catch((requestError) => { if (active) setError(requestError?.response?.data?.message || "We couldn't check your plan access."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  if (loading) return <FetchLoadingState message="Loading..." className="min-h-[50vh]" />;
  if (error) return <main className="mx-auto mt-10 max-w-2xl rounded-2xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-900">{error}</main>;
  if (profile?.enabledFeatures?.[featureKey]) return children;

  const professionalOnly = ["help-desk", "helpdesk", "learning-management-system", "lms"].includes(featureKey);

  return <main className="mx-auto max-w-3xl p-5 font-Nunito sm:p-8">
    <section className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm">
      <div className="bg-gradient-to-br from-[#071C50] to-[#1234CD] p-7 text-white sm:p-10"><span className="inline-flex rounded-xl bg-white/15 p-3"><FiLock className="text-2xl"/></span><p className="mt-5 text-xs font-bold uppercase tracking-[0.18em] text-blue-200">Plan feature</p><h1 className="mt-2 text-3xl font-bold">{title}</h1><p className="mt-3 max-w-xl text-sm leading-6 text-blue-100">{professionalOnly ? `${title} is available to Professional and Custom organizations.` : `${title} is not enabled for this organization.`} Upgrade your plan or ask your CeHR administrator to configure access.</p></div>
      <div className="flex flex-wrap items-center justify-between gap-4 p-6 sm:p-8"><div className="flex items-center gap-3 text-sm text-slate-600"><FiBookOpen className="text-xl text-[#1234CD]"/><span>Current plan: <b className="text-slate-900">{profile?.plan || "Starter"}</b></span></div><Link to="/company-settings/subscription" className="rounded-xl bg-[#1234CD] px-5 py-3 text-sm font-bold text-white hover:bg-[#0D2798]">{professionalOnly ? "Upgrade to Professional" : "View plan options"}</Link></div>
    </section>
  </main>;
}
